"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermFunctionHasLangdir = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
const expressions_1 = require("@comunica/utils-expression-evaluator/lib/expressions");
/**
 *
 */
class TermFunctionHasLangdir extends bus_function_factory_1.TermFunctionBase {
    constructor() {
        super({
            arity: 1,
            operator: utils_expression_evaluator_1.SparqlOperator.HAS_LANGDIR,
            overloads: (0, utils_expression_evaluator_1.declare)(utils_expression_evaluator_1.SparqlOperator.HAS_LANGDIR)
                .onTerm1(() => term => (0, utils_expression_evaluator_1.bool)(term instanceof expressions_1.DirLangStringLiteral))
                .collect(),
        });
    }
}
exports.TermFunctionHasLangdir = TermFunctionHasLangdir;
//# sourceMappingURL=TermFunctionHasLangdir.js.map